import React, {
  FunctionComponent,
  useEffect,
  useState,
  useCallback,
} from 'react'
import './styles.scss'

interface Prize {
  img: string
  prize: string
  desc?: string
}

interface MonthlyLotteryCarouselProps {
  prizes: Prize[]
  drawTs: number | undefined
  remainingDaysText: React.ReactNode
}

const CAROUSEL_AUTO_PLAY_INTERVAL_MS = 4000

const MonthlyLotteryCarousel: FunctionComponent<MonthlyLotteryCarouselProps> =
  React.memo(({ prizes, drawTs, remainingDaysText }) => {
    const [currentIndex, setCurrentIndex] = useState(0)

    const isMultiplePrizes = prizes.length > 1

    const nextSlide = useCallback(() => {
      setCurrentIndex((prev) => (prev + 1) % prizes.length)
    }, [prizes.length])

    useEffect(() => {
      if (!isMultiplePrizes) {
        return
      }

      const interval = setInterval(nextSlide, CAROUSEL_AUTO_PLAY_INTERVAL_MS)
      return () => clearInterval(interval)
    }, [nextSlide, isMultiplePrizes])

    if (prizes.length === 0) {
      return null
    }

    return (
      <div className="k-glm-intro-bottom" style={{ flex: 1 }}>
        <div className="k-glm-carousel-container">
          {isMultiplePrizes ? (
            prizes.map((prize, index) => (
              <img
                key={index}
                className={`twic k-glm-intro-bottom-img ${
                  index === currentIndex ? 'k-glm-carousel-active' : ''
                }`}
                src={undefined}
                data-src={`image:/cdm/kadow/glm/${prize.img}`}
                data-src-transform="cover=WxH"
                style={{
                  width: '100%',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: '100%',
                  opacity: index === currentIndex ? 1 : 0,
                  transition: 'opacity 0.5s ease-in-out',
                }}
                alt={prize.prize}
              />
            ))
          ) : (
            <img
              className="twic k-glm-intro-bottom-img"
              src={undefined}
              data-src={`image:/cdm/kadow/glm/${prizes[0].img}`}
              data-src-transform="cover=WxH"
              style={{
                width: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
              }}
              alt={prizes[0].prize}
            />
          )}
        </div>
        <div className="k-glm-gradient" />
        <p className="k-glm-intro-bottom-text">{remainingDaysText}</p>
      </div>
    )
  })

MonthlyLotteryCarousel.displayName = 'MonthlyLotteryCarousel'

export default MonthlyLotteryCarousel
